/* eslint-disable react/button-has-type */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./loadingSpinner.css";
/**
 * Basic link component, it’s designed to edit the href attribute
 */
const LoadingSpinner = (props) => {
  return (
    <div className="spinner-container">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {};

LoadingSpinner.defaultProps = {};

export default LoadingSpinner;
